import React, { useState } from "react";
import { Dropdown, Menu, Modal, Tooltip } from "antd";
import { Link } from "react-router-dom";
import LoadingSkeleton from "../loading-sekeleton/LoadingSkeleton";
import { COLORS, Typo } from "../../../../../../layout/theme";
import {
	ActionButton,
	AntdTable,
	ColorState,
	Container,
	Section,
	StateContainer,
	TableContainer,
} from "./styles";
import { BsThreeDotsVertical } from "react-icons/bs";
import { numberWithDotAndCommas } from "../../../../../../../utils/numberWithDotAndComas";
import { MdComputer } from "react-icons/md";
import { BiMobile } from "react-icons/bi";
import moment from "moment";
import { FiPhoneCall } from "react-icons/fi";
import { FaHeadset } from "react-icons/fa";
import { AiOutlineAudit } from "react-icons/ai";

export default function MySalesTable({ data, ...props }) {
	const [key, setKey] = useState(null);

	//const [modalInfo, setModalInfo] = useState(null);

	//const [isModalOpen, setIsModalOpen] = useState(false);
	// const showModal = (r) => {
	// 	setIsModalOpen(true);
	// 	setModalInfo(r);
	// };
	// const handleOk = () => {
	// 	setIsModalOpen(false);
	// };
	// const handleCancel = () => {
	// 	setIsModalOpen(false);
	// };

	const menu = (
		<Menu
			items={[
				{
					key: "1",
					label: (
						<Link to={`/admin/ventas/${key}`}>
							<Typo type="secondary">Ver detalle</Typo>
						</Link>
					),
				},
			]}
		/>
	);

	const columns = [
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
						}}
					>
						N° TRF
					</div>
				);
			},
			width: 120,
			dataIndex: "orderNumId",
			render: (f, r) => (
				<Section>
					<Container cursor="pointer" onMouseOver={() => setKey(r?.id)}>
						<Link to={`/admin/ventas/${key}`}>
							<Typo type="primary" fontWeight={600} fontSize={14}>
								{f}
							</Typo>
						</Link>
					</Container>
					<Typo type="mediumGrey" fontWeight={500} fontSize={13}>
						{moment(r.created).format("DD/MM/YYYY")}
					</Typo>
				</Section>
			),
		},
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
						}}
					>
						DROGUERIA
					</div>
				);
			},
			width: 180,
			dataIndex: "distributorName",
			render: (f, record) => (
				<Typo type="darkGrey" fontWeight={600} fontSize={14}>
					{f}
				</Typo>
			),
		},
		// {
		// 	title: () => {
		// 		return (
		// 			<div
		// 				style={{
		// 					color: COLORS.White,
		// 				}}
		// 			>
		// 				Origen
		// 			</div>
		// 		);
		// 	},
		// 	dataIndex: "typeOfSale",
		// 	render: (f, r) => (
		// 		<>
		// 			<Typo
		// 				type="muted"
		// 				fontWeight={600}
		// 				fontSize={14}
		// 				//onClick={() => showModal(r)}
		// 			>
		// 				{f === "WEB" ? (
		// 					<MdComputer />
		// 				) : f === "WEBSELLER" ? (
		// 					<FaHeadset />
		// 				) : f === "EXPO" ? (
		// 					<AiOutlineAudit />
		// 				) : f === "MOBILE" ? (
		// 					<>
		// 						<BiMobile /> App
		// 					</>
		// 				) : (
		// 					<FiPhoneCall />
		// 				)}
		// 			</Typo>
		// 		</>
		// 	),
		// },
		// {
		// 	title: () => {
		// 		return (
		// 			<div
		// 				style={{
		// 					color: COLORS.White,
		// 					fontWeight: 700,
		// 					textAlign: "center",
		// 				}}
		// 			>
		// 				USUARIO
		// 			</div>
		// 		);
		// 	},
		// 	dataIndex: "sellerFirstName",
		// 	render: (f, r) => (
		// 		<Typo type="muted" fontWeight={600} fontSize={14}>
		// 			{f} {r.sellerLastName}
		// 		</Typo>
		// 	),
		// },
		// {
		// 	title: () => {
		// 		return (
		// 			<div
		// 				style={{
		// 					color: COLORS.White,
		// 				}}
		// 			>
		// 				Fecha
		// 			</div>
		// 		);
		// 	},
		// 	dataIndex: "created",
		// 	render: (f) => (
		// 		<Typo type="muted" fontWeight={600} fontSize={14}>
		// 			{moment(f).format("DD/MM/YYYY")}
		// 		</Typo>
		// 	),
		// },
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
						}}
					>
						FARMACIA
					</div>
				);
			},
			dataIndex: "pointOfSaleName",
			render: (f) => (
				<Typo type="darkGrey" fontWeight={600} fontSize={14}>
					{f}
				</Typo>
			),
		},
		// {
		// 	title: () => {
		// 		return (
		// 			<div
		// 				style={{
		// 					color: COLORS.White,
		// 					fontWeight: 700,
		// 				}}
		// 			>
		// 				DIRECCION
		// 			</div>
		// 		);
		// 	},
		// 	dataIndex: "pointOfSaleAddress",
		// 	render: (f) => (
		// 		<Typo type="darkGrey" fontWeight={600} fontSize={14}>
		// 			{f}
		// 		</Typo>
		// 	),
		// },
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
						}}
					>
						PROVINCIA
					</div>
				);
			},
			dataIndex: "provinceName",
			render: (f) => (
				<Typo type="darkGrey" fontWeight={600} fontSize={14}>
					{f}
				</Typo>
			),
		},
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
							textAlign: "center",
						}}
					>
						ITEMS
					</div>
				);
			},
			dataIndex: "qtyItems",
			render: (f) => (
				<div
					style={{
						textAlign: "center",
					}}
				>
					<Typo type="darkGrey" fontWeight={600} fontSize={14}>
						{f}
					</Typo>
				</div>
			),
		},
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
							textAlign: "center",
						}}
					>
						UN.
					</div>
				);
			},
			dataIndex: "qtyUnits",
			render: (f) => (
				<div
					style={{
						textAlign: "center",
					}}
				>
					<Typo type="darkGrey" fontWeight={600} fontSize={14}>
						{f}
					</Typo>
				</div>
			),
		},
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
							textAlign: "end",
						}}
					>
						TOTAL
					</div>
				);
			},
			dataIndex: "total",
			width: 200,
			render: (f, record) => (
				<Section style={{ alignItems: "end" }}>
					<Typo type="primary" fontWeight={700} fontSize={15}>
						$ {numberWithDotAndCommas(parseFloat(f))}
					</Typo>
					{/* <Typo type="success" fontWeight={500} fontSize={13}>
						{f === 0
							? ``
							: `Desc.: $ ${numberWithDotAndCommas(parseFloat(record.discount))} `}
					</Typo> */}
				</Section>
			),
		},
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
							textAlign: "center",
						}}
					>
						ESTADO
					</div>
				);
			},
			dataIndex: "orderState",
			render: (fila, record) => {
				let colorBackground = COLORS.LightGrey3;
				let colorText = COLORS.MediumGrey;

				switch (fila) {
					case "PROCESADA":
						colorBackground = COLORS.LightDefault;
						colorText = COLORS.Default;
						break;
					case "Pending":
						colorBackground = COLORS.LightWarning;
						colorText = COLORS.Warning;
						break;
					case "Active":
						colorBackground = COLORS.LightSecondary;
						colorText = COLORS.Secondary;
						break;
					case "Sended":
						colorBackground = COLORS.LightSuccess;
						colorText = COLORS.Success;
						break;
					case "Canceled":
						colorBackground = COLORS.LightDanger;
						colorText = COLORS.Danger;
						break;

					default:
						break;
				}

				return (
					<StateContainer>
						<ColorState colorBackground={colorBackground}>
							{record.orderSubState ? (
								<Typo fontWeight={600} fontSize={14}>
									{record.orderSubState === "PROCESADA" && "Procesada"}
								</Typo>
							) : (
								<Typo
									fontWeight={600}
									fontSize={14}
									style={{ color: colorText }}
								>
									{fila === "Pending" && "Pendiente"}
									{fila === "Active" && "Activa"}
									{fila === "Sended" && "Enviada"}
									{fila === "Canceled" && "Cancelada"}
								</Typo>
							)}
						</ColorState>
					</StateContainer>
				);
			},
		},
		{
			title: "",
			key: "id",
			dataIndex: "id",
			width: 10,
			render: (f, r, i) => (
				<>
					<Dropdown overlay={menu} placement="bottomRight">
						<ActionButton key={`${f}`} onMouseOver={() => setKey(f)}>
							<BsThreeDotsVertical />
						</ActionButton>
					</Dropdown>
				</>
			),
		},
	];

	if (!data) return <LoadingSkeleton />;

	return (
		<TableContainer>
			<AntdTable columns={columns} dataSource={data} {...props} />
		</TableContainer>
	);
}
